/* eslint-disable no-underscore-dangle */
import { useMemo } from 'react';

import { useDataService } from './ApiDataService';

const baseUrl = '/ipm/v1/saved-filters';

function handleNullResponse(pageId, response) {
    return response === null ? { page: pageId, savedStates: [] } : response;
}

export default function SavedFiltersServiceFactory(dataService) {
    function get(pageId) {
        return dataService.get(`${baseUrl}/${pageId}`).then((response) => handleNullResponse(pageId, response));
    }

    function getShared(pageId) {
        return dataService.get(`${baseUrl}/${pageId}/shared`).then((response) => handleNullResponse(pageId, response));
    }

    function save(pageId, savedFilters) {
        const isNew = !savedFilters._id;
        return dataService[isNew ? 'post' : 'put'](
            `${baseUrl}/${pageId}`,
            savedFilters,
            {},
            {
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        );
    }

    function remove(pageId) {
        return dataService.remove(`${baseUrl}/${pageId}`);
    }

    return {
        get,
        getShared,
        save,
        remove,
    };
}

export function useSavedFiltersService() {
    const dataService = useDataService();
    return useMemo(() => SavedFiltersServiceFactory(dataService), [dataService]);
}
